<div
  *ngIf="selectedStudy"
  class="module-item-core"
  [formGroup]="moduleItemCoreForm"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <mat-form-field *ngIf="selectedStudy?.type === StudyType.CC">
    <input matInput formControlName="label" placeholder="Question label" />
  </mat-form-field>

  <mat-form-field
    appearance="fill"
    *ngIf="selectedStudy.type === StudyType.TIIM && selectedModule?.randomization === RANDOMIZATION_VALUES.CATEGORY"
  >
    <mat-label>Category Label</mat-label>
    <mat-select formControlName="categoryId">
      <mat-option *ngFor="let category of categories" [value]="category?.id">
        {{ category?.label }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="categoryId.hasError('required')"> Category Label is <strong>required</strong></mat-error>
  </mat-form-field>

  <div fxLayout="column">
    <mat-tab-group
      mat-align-tabs="end"
      animationDuration="0ms"
      (selectedTabChange)="selectTemplateLanguage($event)"
      [disablePagination]="true"
      [selectedIndex]="selectedLanguage?.tabIndex"
    >
      <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
        <ng-template matTabContent>
          <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
            <div [formGroupName]="i" fxFill *ngIf="item.get('language').value === selectedLanguage?.code">
              <div *ngIf="item.get('identifier').value === MODULE_ITEM_QUESTION_IDENTIFIER">
                <label class="module-item-core__label">
                  {{ type === ModuleItemAvailableType.INFO ? 'Statement' : 'Question' }}
                </label>
                <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                <mat-error
                  class="module-item-core__label module-item-core__label--error"
                  *ngIf="item.invalid && item.touched"
                >
                  {{ type === ModuleItemAvailableType.INFO ? 'Statement' : 'Question' }}
                  is <strong>required</strong>
                </mat-error>
              </div>
              <div *ngIf="item.get('identifier').value === MODULE_ITEM_DESCRIPTION_IDENTIFIER">
                <label class="module-item-core__label">Description</label>
                <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
              </div>
              <div *ngIf="item.get('identifier').value === MODULE_ITEM_GRAPH_IDENTIFIER">
                <label class="module-item-core__label">Add dynamic text variable</label>
                <editor formControlName="translation" [init]="tinymceInitConfigGraph"></editor>
                <mat-error
                  class="module-item-core__label module-item-core__label--error"
                  *ngIf="item.invalid && item.touched"
                >
                  Choosing Module Item from Dynamic text is <strong>required</strong>
                </mat-error>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <ng-container
    *ngIf="
      selectedStudy?.type !== StudyType.CC &&
      subType !== ModuleItemAvailableSubType.VIDEO_AUDIO &&
      subType !== ModuleItemAvailableSubType.GRAPH &&
      subType !== ModuleItemAvailableSubType.ORBITS &&
      subType !== ModuleItemAvailableSubType.QUADRANT &&
      subType !== ModuleItemAvailableSubType.NETWORK
    "
  >
    <dashboard-image-upload
      formControlName="imagePath"
      [uuid]="imageUploadUuid"
      [label]="'Image'"
      [isEdit]="isEdit"
      [isImageToEdit]="isImageToEdit"
      [imgPath]="imgPath"
      [keyForUpload]="keyForUpload"
      [idsForUpload]="idsForUpload"
    >
    </dashboard-image-upload>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <mat-slide-toggle (change)="toggleVideoInput($event)" [checked]="isVideoInputVisible">Video</mat-slide-toggle>
      <mat-form-field *ngIf="isVideoInputVisible">
        <input matInput formControlName="videoUrl" placeholder="Insert Youtube or Vimeo url" />
      </mat-form-field>
    </div>
  </ng-container>
</div>
